<template>
  <div>
    <b-card v-if="managers.length == 0">
      <b-col sm="12" lg="12">
        <div class="alert alert-danger">
          <ul class="fa-ul" style="margin-bottom: 0px;">
            <li>
              <i class="fa fa-info-circle fa-li"></i>
              There are no managers assigned for current location. <br/>
              Please assign manager using :<br/>
              Click "Dropdown menu" (top right corner) > Click " <i class="nav-icon icon-plus"></i> More" > <i class="nav-icon icon-people"></i> Manager (left hand side menu)

            </li>
          </ul>
        </div>
      </b-col>
    </b-card>
    <b-card v-if="managers.length > 0">
      <b-table responsive="sm" :items="managers" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" style="padding-bottom:0px;">
        <template slot="name" slot-scope="data">
          <div class="avatar">
            <img class="img-avatar" :src="data.item.avatar" :alt="data.item.email" style="margin:10px; height:35px;" v-if="data.item.avatar">
            <img src="https://static.wixstatic.com/media/5b2a92_dc7da9aba3554b5eb93fdcc6a84545d9~mv2.png/v1/fill/w_63,h_64,al_c,usm_0.66_1.00_0.01/5b2a92_dc7da9aba3554b5eb93fdcc6a84545d9~mv2.png" border="0" style="float:left; height:35px; margin:10px;" v-if="(data.item.avatar == '' || data.item.avatar == null)">
            <span class="avatar-status badge-success" style="position: absolute;left: 5px;top: 10px;" v-if="data.item.percentageVal > 25"></span>
            <span class="avatar-status badge-warning" style="position: absolute;left: 5px;top: 10px;" v-if="data.item.percentageVal > 5 && data.item.percentageVal < 25"></span>
            <span class="avatar-status badge-danger" style="position: absolute;left: 5px;top: 10px;" v-if="data.item.percentageVal < 5"></span>
          </div>
        </template>
        <template slot="activeDate" slot-scope="data">
          <small class="text-muted ng-binding">
          <i class="icon-calendar"></i>  {{(new Date(data.item.startDate)).toLocaleString('en-GB', {day: 'numeric',  month: 'short',  year: 'numeric'})}}
          </small>
          <small class="text-muted ng-binding" v-if="(new Date(data.item.endDate).getTime() - new Date().getTime()) < 0" style="color:red !important;">
            <strong> - </strong> {{(new Date(data.item.endDate)).toLocaleString('en-GB', {day: 'numeric',  month: 'short',  year: 'numeric'})}}
          </small>
           <small class="text-muted ng-binding" v-if="(new Date(data.item.endDate).getTime() - new Date().getTime()) > 0">
              <strong> - </strong> {{(new Date(data.item.endDate)).toLocaleString('en-GB', {day: 'numeric',  month: 'short',  year: 'numeric'})}}
            </small>

          <div class="progress progress-xs" style="position:relative;margin-top:15px;width:100%;margin-bottom:5px;" v-if="data.item.percentageVal > 25">
            <div class="progress-bar bg-success" role="progressbar" :style="data.item.percentage" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
          </div>

          <div class="progress progress-xs" style="position:relative;margin-top:15px;width:100%;margin-bottom:5px;" v-if="data.item.percentageVal < 25 && data.item.percentageVal > 5">
            <div class="progress-bar bg-warning" role="progressbar" :style="data.item.percentage" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
          </div>

          <div class="progress progress-xs" style="position:relative;margin-top:15px;width:100%;margin-bottom:5px;" v-if="data.item.percentageVal <= 5">
            <div class="progress-bar bg-danger" role="progressbar" :style="data.item.percentage" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
          </div>
        </template>
        <template slot="contact" slot-scope="data">
          <i class="icon-user" v-if="(data.item.user.gender == 'male' || data.item.user.gender == null)"></i>
          <i class="icon-user-female" v-if="data.item.user.gender == 'female'"></i>
          {{data.item.name}} |
          <i class="icon-phone"></i>
          {{data.item.phone}}
          <a :href="whatsapp(data.item.phone)" :target="data.item.phone"><i class="fa fa-whatsapp"></i></a>
          <br/>
           <i class="icon-envelope"></i> <a :href="mailto(data.item.email)">{{data.item.email}}</a>
        </template>
      </b-table>
      <nav>
        <b-pagination :total-rows="getRowCount(managers)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
      </nav>
    </b-card>
  </div>
</template>

<script>
import ManagerEditForm from '@/views/base/haus/ManagerEditForm'
import ManagerAssign from '@/views/base/haus/ManagerAssign'
let qs = require('qs')

const constants = require('@/views/base/shared/constants')
const BASE = constants.NEWPORT_CONST.API_URL
const API = BASE + '/api/lockManagers/list'
const API_DELETE = BASE + '/api/lockManagers/delete'

function postdata (url, data) {
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
      'accessToken': data.accessToken
    },
    method: 'POST'
  })
    .then(res => res.json())
}

async function getData () {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token'),
    locationId: localStorage.getItem('locationId')
  }
  let res = await postdata(API, parameters)
  return res.lockManagers
}

async function deleteManager (managerId) {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token'),
    locationId: localStorage.getItem('locationId'),
    managerId: managerId
  }
  let res = await postdata(API_DELETE, parameters)
  return res
}

export default {
  name: 'manager-for-location',
  components: {
    ManagerEditForm,
    ManagerAssign
  },
  props: ['locationName', 'locationDescription'],
  data: () => {
    return {
      managers: [],
      fields: {
        name: {
          label: '<i class="icon-user progress-group-icon"></i>'
        },
        contact: {
          label: '<i class="icon-globe"></i>'
        },
        activeDate: {
          label: '<i class="icon-calendar"></i>'
        }
      },
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      filter: null
    }
  },
  mounted () {
    getData().then(response => {
      this.$data.managers = response
    })
  },
  methods: {
    modalassign (i) {
      return 'modalassign' + i
    },
    modalId (i) {
      return 'modal' + i
    },
    modalDeleteId (i) {
      return 'modaldeletemanager' + i
    },
    mailto (email) {
      return 'mailto:' + email
    },
    getRowCount (items) {
      return items.length
    },
    delmanager (managerId) {
      deleteManager(managerId)
      location.reload()
      return managerId
    },
    openlink (link) {
      location.href = link
    },
    handleOk (managerId) {
      deleteManager(managerId)
      location.reload()
    },
    showModal (id, button) {
      this.$root.$emit('bv::show::modal', id, button)
    },
    whatsapp (phone) {
      let phoneNoPlus = phone.slice(1)
      return 'https://api.whatsapp.com/send?phone=' + phoneNoPlus
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/haus/ManagerForLocation.vue